'use client'

import React from 'react'
import Image from 'next/image'
import { CIRCLE_ARROW_URL } from '@constants/contactUs.constants'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getDevicePlatform } from '@utils/segmentProperties'
import { CONTACT_US_EVENTS } from '@configs/contactus.config'
import styles from './styles.module.scss'

const ComplaintSection = ({ tag, title, cta }) => {
  const handleCtaClick = async () => {
    await trackEvent(CONTACT_US_EVENTS.GRIEVANCE_CLICKED.eventName, {
      ...CONTACT_US_EVENTS.GRIEVANCE_CLICKED.eventProps,
      platform: getDevicePlatform(),
    })
  }

  return (
    <div className={styles.complaintBox}>
      <div className={styles.complaintContent}>
        <div className={`${styles.tag} ${styles[`tag--${tag.colorScheme}`]}`}>{tag.text}</div>
        <div className={styles.titleContainer}>
          <a
            href={cta.Link}
            className={styles.cta}
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={handleCtaClick}>
            <div className={styles.title}>{title} </div>
            <div className={styles.ctaContent}>
              {cta.Arrow && <Image src={CIRCLE_ARROW_URL} alt="right-arrow" width={24} height={24} />}
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

export default ComplaintSection
